module.exports = __webpack_public_path__ + "img/designavator.aa2a84c5.jpg";